import {debug, logClientWarn} from '@fitro/customer-features/lib/client-logger'

type ClerkEnv = {
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY?: string
    NEXT_PUBLIC_CLERK_SIGN_IN_URL?: string
    NEXT_PUBLIC_CLERK_SIGN_UP_URL?: string
}

function reportEnvIssue(message: string) {
    if (process.env.NODE_ENV === 'production') {
        throw new Error(message)
    }
    logClientWarn({
        event: 'clerk_env_warning',
        source: 'clerk-env',
        message,
    })
    debug(message, undefined, 'clerk-env')
}

function reportEnvWarning(message: string) {
    logClientWarn({
        event: 'clerk_env_warning',
        source: 'clerk-env',
        message,
    })
    debug(message, undefined, 'clerk-env')
}

export function ensureClerkEnv(env?: ClerkEnv) {
    const resolvedEnv: ClerkEnv = env ?? {
        NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
        NEXT_PUBLIC_CLERK_SIGN_IN_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_URL,
        NEXT_PUBLIC_CLERK_SIGN_UP_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_URL,
    }
    const publishableKey = resolvedEnv.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY
    if (!publishableKey || publishableKey.trim().length === 0) {
        reportEnvIssue('Missing NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY for Clerk.')
    }

    const signInUrl = resolvedEnv.NEXT_PUBLIC_CLERK_SIGN_IN_URL
    if (!signInUrl || signInUrl.trim().length === 0) {
        // Non-fatal: we have runtime fallbacks in ClerkProvider/middleware.
        reportEnvWarning('Missing NEXT_PUBLIC_CLERK_SIGN_IN_URL for Clerk.')
    } else if (signInUrl.startsWith('/admin')) {
        reportEnvWarning('NEXT_PUBLIC_CLERK_SIGN_IN_URL should not start with /admin in the customer app.')
    }

    const signUpUrl = resolvedEnv.NEXT_PUBLIC_CLERK_SIGN_UP_URL
    if (!signUpUrl || signUpUrl.trim().length === 0) {
        // Non-fatal: we have runtime fallbacks in ClerkProvider/middleware.
        reportEnvWarning('Missing NEXT_PUBLIC_CLERK_SIGN_UP_URL for Clerk.')
    } else if (signUpUrl.startsWith('/admin')) {
        reportEnvWarning('NEXT_PUBLIC_CLERK_SIGN_UP_URL should not start with /admin in the customer app.')
    }
}
